import { useEffect, useState } from "react"
import { useConf } from "../../context/account/paramsAccount"
import { formatDate } from "../../functions/date/formatageDate"
import { useNavigate } from 'react-router-dom';
import { RecapPresta, usePresta } from "../../context/presta/fichePresta"
import { useError } from "../../context/erreur/erreurContext"
import { useParams } from 'react-router-dom';
import { hookApi } from "../../hook/presta/affichePrestaHook"
import { loadModeHorsligne } from "../../functions/HorsLigne/loadmodeHL"
import { saveHl } from "../../functions/HorsLigne/saveHL"
import { savePrestaHorsligne } from "../../functions/localStorage/saveLocalStorage"
import { Storage } from "@capacitor/storage";
import AnimationLoading from "../../components/animationLoading/animationLoading"

interface ListePresta {
    dev_id: string,
    pv_id: string,
    e_dp_id: number | null,
    v_cli_civ_nom: string,
    v_date_presta: string,
    v_designation: string,
    v_num_piece: string,
    v_adr_livraison: string,
    v_mode_vente: string,
    v_cnt_civ_nom: string,
    v_cnt_tel_mobile: string,
    e_nom_responsable: string,
}

export function RetourPresta() {
    const navigate = useNavigate();
    const { id: rawId } = useParams<{ id: string }>();
    const id = Number(rawId); // Conversion explicite en nombre
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { conf, setConf } = useConf()
    const { showError } = useError();
    const { setPresta } = usePresta()
    const [listePresta, setListePresta] = useState([])
    const [selectedItem, setSelectedItem]: any = useState({})
    useEffect(() => {
        if (conf.token) {
            if (conf?.conf?.ifOffLineMode === false) {
                hookApi('/posts/liste-presta', { id }, conf, setConf, setListePresta, showError)
            }
        }
    }, [conf.token, conf])

    const handleCardClick = (data: RecapPresta) => {
        setIsLoading(true)
        setSelectedItem(data)
        setPresta((prevState): RecapPresta => ({
            ...prevState,
            pv_id: data.pv_id,
            dev_id: data.dev_id,
            e_dp_id: data.e_dp_id,
            v_num_piece: data.v_num_piece,
            v_designation: data.v_designation,
            v_date_presta: data.v_date_presta,
            v_cli_civ_nom: data.v_cli_civ_nom,
            v_adr_livraison: data.v_adr_livraison,
            v_cnt_civ_nom: data.v_cnt_civ_nom,
            v_cnt_tel_mobile: data.v_cnt_tel_mobile,
            v_mode_vente: data.v_mode_vente
        }));
        const dataSends = {
            e_pv_id: parseInt(data.pv_id, 10),
            e_dev_id: parseInt(data.dev_id, 10),
            e_dp_id: null
        };
        const enregistrerDataHl = (type: string) => {
            if (conf.conf.ifOffLineMode === false) {
                const requests = () => {
                    const dataSend = dataSends
                    return saveHl('/posts/affiche-presta', dataSend, conf.token, conf, setConf, showError)
                        .then((response: any) => response);
                };

                Promise.all([requests()])
                    .then((results: any[]) => {
                        const combinedResults = results.flat();

                        // Prendre uniquement la première prestation
                        const newPrestation = combinedResults[0];  // Prendre uniquement la prestation souhaitée

                        // Vérifier si cette prestation existe déjà dans le local storage
                        return Storage.get({ key: `prestaHl_${conf.user.user_code}` }).then((existingPrestations: any) => {
                            const existingPrestationsData = existingPrestations.value ? JSON.parse(existingPrestations.value) : [];

                            // Vérifier si la prestation existe déjà
                            const prestationExists = existingPrestationsData.some((existing: any) =>
                                existing.entete.v_num_piece === newPrestation.entete.v_num_piece
                            );

                            if (prestationExists) {
                                navigate("/affiche-presta", { state: { pvId: data.pv_id, devId: data.dev_id, dpId: data.e_dp_id } });
                                return;
                            }
                            // Ajouter la nouvelle prestation à la liste existante
                            const updatedPrestations = [...existingPrestationsData, newPrestation];
                            // Enregistrer les prestations mises à jour dans le stockage local
                            return savePrestaHorsligne(updatedPrestations, 'prestaHl', conf, setConf).then(() => {
                                setSelectedItem([]);  // Réinitialiser la sélection d'éléments si nécessaire
                                navigate("/affiche-presta", { state: { pvId: data.pv_id, devId: data.dev_id, dpId: data.e_dp_id } });
                            });
                        });
                    })
                    .catch(error => {
                        console.error('Erreur lors de la récupération des détails :', error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            } else {
                navigate("/affiche-presta", { state: { pvId: data.pv_id, devId: data.dev_id, dpId: data.e_dp_id } });
            }
        }
        // Appel de la fonction
        enregistrerDataHl("presta");
    }
    useEffect(() => {
        if (conf?.conf?.ifOffLineMode === true) {
            loadModeHorsligne('prestaHl', conf)
                .then(data => {
                    if (data) {
                        const entetes = data.map((item: any) => item.entete);
                        if (entetes) {
                            setListePresta(entetes)
                        }
                    }
                })
                .catch(error => console.error('Erreur lors du chargement des données hors ligne :', error));
        }
    }, [conf])
    return (
        <div className="container_presta">
            {listePresta?.length > 0 ?
                listePresta?.map((data: ListePresta) => (
                    <div key={data.v_num_piece} className="card_presta" onClick={(e) => handleCardClick(data)}>
                        <div className="header_card_presta">
                            <div className="header_text_presta">
                                <p>{data?.v_num_piece !== "" ? data?.v_num_piece : ""}</p>
                                <p>{data?.v_date_presta !== "" ? formatDate(data?.v_date_presta) : ""}</p>
                            </div>
                            <p className="modevente_text">{data?.v_mode_vente}</p>
                        </div>
                        <div className="body_card_presta">
                            <p>{data?.v_designation !== "" ? data?.v_designation : ""}</p>
                        </div>
                        <div className="footer_card_presta">
                            <p className="overflow">{data?.v_cli_civ_nom !== "" ? data?.v_cli_civ_nom : ""}</p>
                            <p className="livraison_text overflow">{data?.v_adr_livraison !== "" ? data?.v_adr_livraison : ""}</p>
                        </div>
                    </div>
                )) : <p>Aucune prestation disponible.</p>
            }
            <AnimationLoading
                isLoading={isLoading}
                text="fdsf" />
        </div>
    )
}